import ReactDOM from "react-dom";
import { useContext, useRef, useState, useMemo } from "react";
import { useOutsideClickForTwoRef } from "../../../Hooks/useOutsideClickForTwoRef";
import { sizeOptions } from "../SizeChartFormsData";
import { AddSizeChartContext } from "../../../Context/AddSizeChartContext";

function SizeNameInput({ row, isLast }) {
    const dropdownRef = useRef(null);
    const dropdownButtonRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });

    const { sizeChartFormData, setSizeChartFormData } = useContext(AddSizeChartContext);

    useOutsideClickForTwoRef(dropdownRef, dropdownButtonRef, () => {
        setDropdownOpen(false);
    });

    const selectedSizes = useMemo(() => {
        return sizeChartFormData
            .filter(item => item.id !== row.id && item.sizeName)
            .map(item => item.sizeName);
    }, [sizeChartFormData, row.id]);

    const availableOptions = useMemo(() => {
        return sizeOptions.filter(size => !selectedSizes.includes(size.title));
    }, [selectedSizes]);

    function handleOpenDropdown() {
        if (!dropdownOpen && dropdownButtonRef.current) {
            const rect = dropdownButtonRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
            });
        }
        setDropdownOpen(!dropdownOpen);
    }

    function handleSelectOption(rowId, size) {
        const updatedData = sizeChartFormData.map((item) => {
            if (item.id === rowId) {
                return { ...item, sizeName: size };
            }
            return item;
        });
        setSizeChartFormData(updatedData);
        setDropdownOpen(false);
    }

    return (
        <>
            <div
                ref={dropdownButtonRef}
                onClick={handleOpenDropdown}
                className={`w-[180px] px-6 py-3 ${!isLast && 'border-r border-[#EAEAEA]'} relative cursor-pointer`}
            >
                <p className={`text-[16px] leading-[22px] font-normal text-center ${row.sizeName ? 'text-[#121212]' : 'text-[#666666]'}`}>
                    {row.sizeName ? row.sizeName : 'input'}
                </p>
            </div>

            {dropdownOpen &&
                ReactDOM.createPortal(
                    <div
                        ref={dropdownRef}
                        style={{
                            position: "absolute",
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `${dropdownPosition.width}px`,
                            zIndex: 9999,
                        }}
                        className="bg-white shadow-[0px_0px_12px_0px_#0000003D] rounded-md text-[14px] leading-5 font-semibold text-[#666666] max-h-44 overflow-y-auto"
                    >
                        {availableOptions.length > 0 ? (
                            availableOptions.map((size) => (
                                <div
                                    key={size.id}
                                    onClick={() => handleSelectOption(row.id, size.title)}
                                    className="px-6 py-3 text-center hover:bg-[#EFEFEF] cursor-pointer"
                                >
                                    <p>{size.title}</p>
                                </div>
                            ))
                        ) : (
                            <div className="w-full px-6 py-3 text-center text-gray-400">
                                <p>No sizes available</p>
                            </div>
                        )}
                    </div>,
                    document.body // 👈 renders outside scrollable container
                )}
        </>
    );
}

export default SizeNameInput;
